import React from "react";
import { motion } from "framer-motion";

/**
 * MaskedLines — animates each provided line with a mask reveal.
 * Renders each line inside overflow:hidden and translates the inner span from y:100% -> 0.
 * Use for hero and section headings.
 */
export default function MaskedLines({
    lines = [],
    className = "",
    lineClassName = "",
    delay = 0,
    stagger = 0.12,
    duration = 1.1,
    as = "h1",
    testid,
}) {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            data-testid={testid}
            className={className}
            initial="hidden"
            animate="visible"
            variants={{
                hidden: {},
                visible: {
                    transition: {
                        staggerChildren: stagger,
                        delayChildren: delay,
                    },
                },
            }}
        >
            {lines.map((line, i) => (
                <span key={i} className={`reveal-mask ${lineClassName}`}>
                    <motion.span
                        variants={{
                            hidden: { y: "110%" },
                            visible: {
                                y: "0%",
                                transition: {
                                    duration,
                                    ease: [0.16, 1, 0.3, 1],
                                },
                            },
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}
